import React, { useEffect, useState } from "react";
import { Table, Spinner, Pagination } from "react-bootstrap";
import axios from "axios";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;

function ToatalSales() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    mobile: "",
    bysqrt: "",
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    limit: 20,
  });

  const [isFilterActive, setIsFilterActive] = useState(false);
  const handleToggle = () => setIsFilterActive(!isFilterActive);

  const getAuthToken = () => localStorage.getItem("token");

  const fetchData = async (page = 1, filterData = filters) => {
    setLoading(true);
    const token = getAuthToken();

    if (!token) {
      alert("Authentication token not found.");
      setLoading(false);
      return;
    }

    try {
      const params = {
        page,
        limit: pagination.limit,
        mobile: filterData.mobile || "",
        buysqrt: filterData.bysqrt || "",
      };

      const response = await axios.get(
        `${API_URL}/giftself-to-associate-by-admin-list`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        }
      );

      if (response.data.success === true) {
        setData(response.data.data || []);
        setPagination((prev) => ({
          ...prev,
          currentPage: response.data.pagination.page,
          totalPages: response.data.pagination.totalPages,
          totalItems: response.data.pagination.total,
        }));
      } else {
        setData([]);
        setPagination((prev) => ({
          ...prev,
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
        }));
      }
    } catch (error) {
      console.error("API Error:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(pagination.currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
    fetchData(1, filters);
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= pagination.totalPages) {
      setPagination((prev) => ({ ...prev, currentPage: page }));
    }
  };

  const getPaginationGroup = () => {
    let pages = [];
    const totalPagesToShow = 7;
    const sidePages = 2;

    if (pagination.totalPages <= totalPagesToShow) {
      for (let i = 1; i <= pagination.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    let startPage = Math.max(2, pagination.currentPage - sidePages);
    let endPage = Math.min(
      pagination.totalPages - 1,
      pagination.currentPage + sidePages
    );

    pages.push(1);

    if (startPage > 2) {
      pages.push("...");
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < pagination.totalPages - 1) {
      pages.push("...");
    }

    if (pagination.totalPages > 1) {
      pages.push(pagination.totalPages);
    }

    return pages;
  };

  // ═══════════ INLINE STYLES ═══════════
  const gradientBg =
    "linear-gradient(135deg, #1e1b4b 0%, #3b0f6b 50%, #4c1d95 100%)";

  const styles = {
    filterToggle: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "42px",
      height: "42px",
      padding: 0,
      border: isFilterActive
        ? "1px solid #ffffff"
        : "1px solid rgba(255, 255, 255, 0.3)",
      background: isFilterActive ? "#ffffff" : "rgba(255, 255, 255, 0.15)",
      color: isFilterActive ? "#1e1b4b" : "#ffffff",
      borderRadius: "10px",
      fontSize: "18px",
      cursor: "pointer",
      transition: "all 0.25s ease",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      backdropFilter: "blur(6px)",
    },
    searchBtn: {
      height: "44px",
      padding: "0 28px",
      fontSize: "13.5px",
      fontWeight: 700,
      color: "#fff",
      background: gradientBg,
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      whiteSpace: "nowrap",
      boxShadow: "0 4px 14px rgba(76, 29, 149, 0.35)",
      transition: "all 0.22s ease",
      margin: 0,
      flexShrink: 0,
    },
    filterInput: {
      flex: "1 1 0",
      minWidth: 0,
      height: "44px",
      padding: "0 16px",
      fontSize: "13.5px",
      border: "1.5px solid #e2e8f0",
      borderRadius: "10px",
      background: "#fff",
      color: "#0f172a",
      outline: "none",
      boxSizing: "border-box",
      margin: 0,
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    },
  };

  return (
    <div className="padding_15">
      <div className="card">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center">
            <div className="titlepage">
              <h3 className="mb-0">Toatal Sales</h3>
            </div>

            {/* ═══════════ FILTER TOGGLE ═══════════ */}
            <button
              onClick={handleToggle}
              title={isFilterActive ? "Hide Filters" : "Show Filters"}
              style={styles.filterToggle}
              onMouseEnter={(e) => {
                if (!isFilterActive) {
                  e.currentTarget.style.background =
                    "rgba(255, 255, 255, 0.25)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isFilterActive) {
                  e.currentTarget.style.background =
                    "rgba(255, 255, 255, 0.15)";
                  e.currentTarget.style.transform = "translateY(0)";
                }
              }}
            >
              {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
            </button>
          </div>
        </div>

        <div className="card-body">
          {/* ═══════════ FILTER SECTION ═══════════ */}
     {isFilterActive && (
  <form
    onSubmit={handleFilterSubmit}
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "12px",
      alignItems: "center",
      marginBottom: "20px",
      width: "100%",
    }}
  >
    <input
      type="text"
      name="mobile"
      value={filters.mobile}
      onChange={handleFilterChange}
      placeholder="Search by Mobile"
      style={{
        flex: "1 1 200px",        // ← desktop pe flexible, mobile pe full width
        minWidth: 0,
        height: "44px",
        padding: "0 16px",
        fontSize: "13.5px",
        border: "1.5px solid #e2e8f0",
        borderRadius: "10px",
        background: "#fff",
        color: "#0f172a",
        outline: "none",
        boxSizing: "border-box",
        margin: 0,
        transition: "border-color 0.2s ease, box-shadow 0.2s ease",
      }}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = "#6366f1";
        e.currentTarget.style.boxShadow =
          "0 0 0 4px rgba(99, 102, 241, 0.12)";
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = "#e2e8f0";
        e.currentTarget.style.boxShadow = "none";
      }}
    />

    <input
      type="text"
      name="bysqrt"
      value={filters.bysqrt}
      onChange={handleFilterChange}
      placeholder="Search by SQYD"
      style={{
        flex: "1 1 200px",
        minWidth: 0,
        height: "44px",
        padding: "0 16px",
        fontSize: "13.5px",
        border: "1.5px solid #e2e8f0",
        borderRadius: "10px",
        background: "#fff",
        color: "#0f172a",
        outline: "none",
        boxSizing: "border-box",
        margin: 0,
        transition: "border-color 0.2s ease, box-shadow 0.2s ease",
      }}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = "#6366f1";
        e.currentTarget.style.boxShadow =
          "0 0 0 4px rgba(99, 102, 241, 0.12)";
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = "#e2e8f0";
        e.currentTarget.style.boxShadow = "none";
      }}
    />

    <button
      type="submit"
      style={{
        height: "44px",
        padding: "0 28px",
        fontSize: "13.5px",
        fontWeight: 700,
        color: "#fff",
        background:
          "linear-gradient(135deg, #1e1b4b 0%, #3b0f6b 50%, #4c1d95 100%)",
        border: "none",
        borderRadius: "10px",
        cursor: "pointer",
        whiteSpace: "nowrap",
        boxShadow: "0 4px 14px rgba(76, 29, 149, 0.35)",
        transition: "all 0.22s ease",
        margin: 0,
        flexShrink: 0,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow =
          "0 8px 20px rgba(76, 29, 149, 0.5)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "0 4px 14px rgba(76, 29, 149, 0.35)";
      }}
    >
      Search
    </button>
  </form>
)}

          {loading ? (
            <div className="text-center my-5">
              <Spinner animation="border" />
              <p className="mt-2">Loading data...</p>
            </div>
          ) : (
            <>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Gifted SQYD</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={item.user_id || index}>
                        <td>
                          {(pagination.currentPage - 1) * pagination.limit +
                            index +
                            1}
                        </td>
                        <td>{item.username || "N/A"}</td>
                        <td>{item.mobile || "N/A"}</td>
                        <td>{item.buysqrt || "N/A"}</td>
                        <td>
                          {item.date
                            ? new Date(item.date).toLocaleDateString("en-GB")
                            : "N/A"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {pagination.totalPages > 1 && (
                <Pagination className="justify-content-center">
                  <Pagination.Prev
                    onClick={() =>
                      handlePageChange(pagination.currentPage - 1)
                    }
                    disabled={pagination.currentPage === 1}
                  />
                  {getPaginationGroup().map((item, index) => (
                    <Pagination.Item
                      key={index}
                      active={item === pagination.currentPage}
                      onClick={() =>
                        typeof item === "number"
                          ? handlePageChange(item)
                          : null
                      }
                      disabled={item === "..."}
                      style={{
                        cursor: item === "..." ? "default" : "pointer",
                      }}
                    >
                      {item}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next
                    onClick={() =>
                      handlePageChange(pagination.currentPage + 1)
                    }
                    disabled={
                      pagination.currentPage === pagination.totalPages
                    }
                  />
                </Pagination>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ToatalSales;